<template>
  <div class="table" v-loading="loading">
    <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
        :cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
        :height="tableHeigth"
        :stripe="true"
        size="mini"
    >
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="planName" label="志愿方案名称"></el-table-column>
      <el-table-column prop="admitBatch" label="批次"></el-table-column>
      <el-table-column label="志愿模式">
        <template slot-scope="scope">
          <div v-if="scope.row.voPa === 1">院校模式</div>
          <div v-if="scope.row.voPa === 3">专业组模式</div>
          <div v-if="scope.row.voPa === 2">专业模式</div>
        </template>
      </el-table-column>
      <el-table-column prop="planNum" label="志愿数量"></el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.isFormal === 1" class="statusTv">志愿方案</div>
          <div v-if="scope.row.isFormal === 0"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button
              type="text"
              style="font-size: 14px"
              @click="addOrViewDraftPlan(scope.row.draftId, scope.row.admitBatch)"
          >查看
          </el-button>
          <el-button
              type="text"
              style="font-size: 14px"
              @click="updatePlanNameClick(scope.row.draftId)"
              v-permission="'400111'"
          >修改名称
          </el-button
          >
          <el-button
              type="text"
              style="font-size: 14px"
              @click="copy(scope.row.draftId)"
          >复制
          </el-button
          >
          <el-button
              type="text"
              style="color: #e6a23c; font-size: 14px"
              @click="setFormalClick(scope.row.draftId)"
              v-permission="'400110'"
              v-if="scope.row.isFormal === 0"
          >设为志愿方案
          </el-button
          >
          <el-button
              type="text"
              style="color: #f78989; font-size: 14px"
              @click="cancelFormal(scope.row.draftId)"
              v-permission="'400110'"
              v-if="scope.row.isFormal === 1"
          >取消志愿方案
          </el-button
          >
          <el-button
              type="text"
              style="color: #f78989; font-size: 14px"
              @click="deleteDraftClick(scope.row)"
              v-permission="'400111'"
          >删除
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="button">
      <el-button
          type="primary"
          size="small"
          @click="addOrViewDraftPlan()"
          v-permission="'400109'"
      >添加志愿方案
      </el-button>
      <el-button
          type="primary"
          size="small"
          v-permission="'400109'"
          @click="showImportDraftPlan"
      >导入志愿方案
      </el-button>
      <el-button
          type="primary"
          size="small"
          @click="showAddTemplateDialogClick"
          v-permission="'400109'"
      >添加模板方案
      </el-button>
      <el-button
          type="warning"
          size="small"
          style="margin-left: 10px"
          v-permission="'400109'"
      >
        <a
            :href="`${path}excel/zyfadr.xlsx`"
            download="志愿方案导入模板.xlsx"
            style="color: #fff"
        >下载导入模板</a
        >
      </el-button>
    </div>

    <el-dialog
        title="选择志愿模板"
        :visible.sync="showAddTemplateDialog"
        @closed="reset"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="90%"
    >
      <div class="flexsb">
        <el-form :inline="true" :model="planParams" class="demo-form-inline">
          <el-form-item label="年份:">
            <el-select
                disabled
                v-model="planParams.year"
                size="small"
                placeholder="请选择"
                style="width: 100px; margin-right: 20px"
            >
              <el-option
                  v-for="(item, index) in yearList"
                  :key="index"
                  :label="item"
                  :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省份:">
            <el-select
                disabled
                v-model="planParams.provinceId"
                size="small"
                placeholder="请选择"
                style="width: 100px; margin-right: 20px"
                @change="provinceChange"
            >
              <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次:">
            <el-select
                v-model="planParams.adminBatch"
                size="small"
                placeholder="请选择"
                style="width: 150px; margin-right: 20px"
                @change="templateBatchChanged"
            >
              <el-option
                  v-for="item in batchList"
                  :key="item.batchId"
                  :label="item.batch"
                  :value="item.batch"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务专家:">
            <el-select
                clearable
                v-model="planParams.expertId"
                placeholder="请选择"
                size="small"
                style="width: 100px; margin-right: 20px"
            >
              <el-option
                  v-for="item in serviceExpertList"
                  :key="item.expertId"
                  :label="item.expertName"
                  :value="item.expertId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                size="small"
                @click="search"
            >查询
            </el-button
            >
            <el-button size="small" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button
              type="primary"
              size="small"
              @click="addDraftPlanFromTemplate"
          >确定
          </el-button>
        </div>
      </div>
      <div>
        <el-table
            :stripe="true"
            height="500"
            :data="volunteerTemplateList"
            border
            style="width: 100%; margin-bottom: 15px"
            @select="selectTemplatePlan" @row-click="templateRowClick"
            ref="eltableCurrentRow"
            :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
            :cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
        >
          <el-table-column type="selection" label="选择" width="80"></el-table-column>
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column
              prop="templateName"
              label="模板方案名称"
              width="180"
              show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="性别" width="60">
            <template slot-scope="scope">
              {{ scope.row.sex === 0 ? "男" : "女" }}
            </template>
          </el-table-column>
          <el-table-column prop="province" label="所在省份" width="100">
          </el-table-column>
          <el-table-column prop="year" label="毕业年份" width="80">
          </el-table-column>
          <el-table-column prop="admitBatch" label="批次" width="130">
          </el-table-column>
          <el-table-column label="科别类型" width="80">
            <template slot-scope="scope">
              {{ matchDisciplineType(scope.row.disciplineType) }}
            </template>
          </el-table-column>
          <el-table-column label="志愿模式" width="100">
            <template slot-scope="scope">
              {{ matchVolunteerMode(scope.row.voPa) }}
            </template>
          </el-table-column>
          <el-table-column prop="planNum" label="志愿数量" width="80">
          </el-table-column>
          <el-table-column label="高考成绩" width="80">
            <template slot-scope="scope">
              {{ scope.row.adminScore ? scope.row.adminScore : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="expertName" label="服务专家" width="100">
          </el-table-column>
          <el-table-column prop="templateRemarks" label="备注" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div class="select-template-footer">
          <el-pagination
              background
              @current-change="pageChange"
              :current-page.sync="planParams.current"
              layout="prev, pager, next"
              :total="planTotal"
              :page-size="planParams.size"
          >
          </el-pagination>

          <div class="hint">
            注：请选择相同志愿模式的志愿模板方案
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="添加志愿方案"
        :visible.sync="dialogVisible"
        width="450px"
        @open="openDialog"
    >
      <el-form :model="draftform">
        <el-form-item label="志愿方案名称:" label-width="140px">
          <el-input
              v-model="draftform.planName"
              size="small"
              style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="志愿方案批次:" label-width="140px">
          <el-select
              style="width: 200px; margin-right: 20px"
              v-model="draftform.batch"
              size="small"
              placeholder="请选择"
              value-key="batch"
          >
            <el-option
                v-for="item in batchs"
                :key="item.batch"
                :label="item.batch"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addDraftPlanConfirm" size="small"
        >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="复制草稿" :visible.sync="dialogCopy" width="450px">
      <el-form :model="copyForm">
        <el-form-item label="志愿方案名称:" label-width="140px">
          <el-input
              v-model="copyForm.planName"
              size="small"
              style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCopy = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="copyDraft"
        >确 定
        </el-button
        >
      </div>
    </el-dialog>

    <el-dialog
        title="导入志愿方案"
        :visible.sync="dialogFormVisible"
        width="450px"
        @close="dialogFormClose"
        :close-on-click-modal="false"
    >
      <el-form :model="uploadParams">
        <el-form-item label="方案批次:" label-width="140px">
          <el-select
              style="width: 200px; margin-right: 20px"
              v-model="uploadParams.admitBatch"
              size="small"
              placeholder="请选择"
              value-key="batch"
          >
            <el-option
                v-for="item in batchs"
                :key="item.batch"
                :label="item.batch"
                :value="item.batch"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方案名称:" label-width="140px">
          <el-input
              v-model="uploadParams.draftPlanName"
              size="small"
              style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择文件:" label-width="140px">
          <el-upload
              class="upload"
              ref="upload"
              :file-list="fileList"
              action="/com/had-login/aspiration/aspiration-draft/importDraftPlan"
              :headers="uploadheaders"
              :data="uploadParams"
              :limit="1"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              :on-change="handleChange"
              :on-remove="fileRemove"
              :on-success="importSuccess"
              :on-error="importFailed"
              :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary"
            >选取文件
            </el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small"
        >取 消
        </el-button
        >
        <el-button type="primary" @click="submitUpload" size="small"
        >确 定
        </el-button
        >
      </div>
    </el-dialog>

    <el-dialog
        title="修改方案名称"
        :visible.sync="showUpdatePlanNameDialog"
        width="450px"
    >
      <el-form :model="updatePlanNameParam">
        <el-form-item label="志愿方案名称:" label-width="140px">
          <el-input
              v-model="updatePlanNameParam.planName"
              size="small"
              style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUpdatePlanNameDialog = false" size="small"
        >取 消</el-button
        >
        <el-button type="primary" @click="updatePlanNameConfirm" size="small"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addDraftPlanFromTemplate,
  cancelFormal,
  copyDraft,
  deleteDraft,
  getDraftList,
  getStudentDetail,
  getVolunteerTemplatePlan,
  setFormal,
  updateDraftPlanName
} from "@/api/serviceManagement.js";
import lpyMixin from "@/mixin/lpyMixin";
import {getProvinceList} from "@/api/index.js";
import {getExpertList} from "@/api/commodityManagement.js";
import {getOneProvince} from "@/api/systemManagement.js";

export default {
  mixins: [lpyMixin],
  props: ["id", "oneId"],
  data() {
    return {
      path: process.env.BASE_URL,
      loading: false,
      uploadheaders: {
        sessionId: sessionStorage.getItem("sessionId") || "",
      },
      dialogFormVisible: false,
      uploadform: {},
      uploadParams: {
        admitBatch: "",
        draftPlanName: "",
      },
      dialogCopy: false,
      batch: {},
      draftform: {
        remark: "无",
      },
      copyForm: {
        remark: "无",
      },
      dialogVisible: false,
      tableData: [],
      userform: {},
      idOne: "",
      draftId: "",
      userid: "",
      user: {},
      showAddTemplateDialog: false,
      showUpdatePlanNameDialog: false,
      updatePlanNameParam: {
        draftId: null,
        planName: null,
      },
      planParams: {
        size: 20,
        year: new Date().getFullYear(),
        current: 1,
        provinceId: "",
        expertId: "",
        studentName: "",
        adminBatch: "",
        disciplineType: null
      },
      yearList: [],
      provinceList: [],
      batchList: [],
      templateSelectBatch: {},
      serviceExpertList: [],
      planRemarkList: [],
      volunteerTemplateList: [],
      planTotal: 0,
      expertParams: {},
      appleyPramas: {},
      batchs: [],
      fileList: [],
      voPa: 0,
      selectDraftIdList: [],
      selectDraftList: [],
    };
  },
  watch: {
    oneId: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.idOne = newValue;
        if (this.idOne) {
          this.uploadParams.oneId = this.idOne;
          console.log("志愿草稿 watch")
          this.getDraftList();
        }
      },
      deep: true,
    },
    id: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.userid = newValue;
        this.getStudentDetail(this.userid);
      },
      deep: true,
    },
  },
  mounted() {
    this.calculateYear();
    this.obtainProvinceList();
    // this.$nextTick(function () {
    //   console.log("志愿草稿 mounted")
    //   this.getDraftList();
    // });
  },
  methods: {
    sure() {
      this.showAddTemplateDialog = false;
      this.getDraftList();
    },
    templateRowClick(row, col, event) {
      row.flag = !row.flag;
      let flag = !this.selectDraftIdList.includes(row.draftId);
      this.$refs.eltableCurrentRow.toggleRowSelection(row, flag);
      if (this.selectDraftIdList.includes(row.draftId)) {
        this.selectDraftIdList.splice(this.selectDraftIdList.indexOf(row.draftId), 1);
        this.selectDraftList = this.selectDraftList.filter(function (item) {
          return item.draftId !== row.draftId;
        });
      } else {
        this.selectDraftIdList.push(row.draftId);
        this.selectDraftList.push(row);
      }
    },
    selectTemplatePlan(data, val) {
      if (this.selectDraftIdList.includes(val.draftId)) {
        this.selectDraftIdList.splice(this.selectDraftIdList.indexOf(val.draftId), 1);
        this.selectDraftList = this.selectDraftList.filter(function (item) {
          return item.draftId !== val.draftId;
        });
      } else {
        this.selectDraftIdList.push(val.draftId);
        this.selectDraftList.push(val);
      }
    },
    dialogFormClose() {
      this.uploadParams.admitBatch = "";
      this.uploadParams.draftPlanName = "";
    },
    submitUpload() {
      let tempThis = this;
      if (!tempThis.uploadParams.admitBatch) {
        this.$message.error("请选择批次");
        return;
      }
      if (!tempThis.uploadParams.draftPlanName) {
        this.$message.error("请输入方案名称");
        return;
      }
      if (this.fileList.length === 0) {
        this.$message.error("请选择志愿方案文件");
        return;
      }

      this.$refs.upload.submit();
      this.loading = true;
      this.dialogFormVisible = false;
    },

    copy(id) {
      this.dialogCopy = true;
      this.copyForm.draftId = id;
      this.copyForm.oneId = this.idOne;
      this.copyForm.planName = "";
      this.copyForm.remark = "";
      this.copyForm = {...this.copyForm};
    },

    copyDraft() {
      if (!this.copyForm.planName || !this.copyForm.planName.trim()) {
        this.$message.error("请输入方案名称");
        return;
      }
      copyDraft(this.copyForm).then((res) => {
        if (res.code === 1) {
          this.dialogCopy = false;
          this.getDraftList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    openDialog() {
      this.draftform = {};
    },
    //获取学生详情
    getStudentDetail(id) {
      getStudentDetail({studentId: id}).then((res) => {
        this.user = res.data || {};
        this.planParams.provinceId = this.user.province;
        this.planParams.year = this.user.graduateYear;

        this.getOneProvince();
      });
    },
    //获取列表
    getDraftList() {
      getDraftList({oneId: this.idOne}).then((res) => {
        this.tableData = res.data || [];
      });
    },
    deleteDraftClick(plan) {
      this.draftId = plan.draftId;
      this.$confirm(plan.isFormal && plan.isFormal === 1 ? "该方案为志愿方案，是否删除该志愿方案？" : "是否删除该志愿方案？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            if (plan.isFormal === 1) {
              //当前是志愿方案，先取消，再删除
              cancelFormal({draftId: plan.draftId}).then((res) => {
                if (res.code === 1) {
                  this.deleteDraft();
                } else {
                  this.$message.error(res.msg);
                }
              });
            } else {
              this.deleteDraft();
            }
          })
          .catch(() => {
            console.log("删除");
          });
    },
    cancelFormal(draftId) {
      this.$confirm("是否取消该志愿方案？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            cancelFormal({draftId: draftId}).then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功");
                this.getDraftList();
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {
          });
    },
    deleteDraft() {
      deleteDraft({draftId: this.draftId}).then((res) => {
        if (res.code === 1) {
          this.$message.success("删除成功");
          this.getDraftList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    setFormalClick(id) {
      this.draftId = id;
      this.$confirm("是否将该方案设置成为志愿方案？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.setFormal();
          })
          .catch(() => {
          });
    },
    /**
     * 设置志愿方案
     */
    setFormal() {
      setFormal({draftId: this.draftId}).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "设为志愿方案成功",
            type: "success",
          });
          this.getDraftList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取批次
    getOneProvince() {
      getOneProvince({
        year: this.user.graduateYear,
        areaProvinceId: this.user.province,
      }).then((res) => {
        let data = res.data || {};
        this.batchs = data.batchs || [];
        this.batchList = data.batchs || [];
        if (this.batchList.length > 0) {
          this.templateSelectBatch = this.batchList[0];
        }
      });
    },

    templateBatchChanged(batch) {
      if (this.batchList.length > 0) {
        this.templateSelectBatch = this.batchList.find(item => item.batch === batch)
      }
      console.log(this.templateSelectBatch, "批次选择")
    },
    /**
     * 添加或查看草稿方案
     * @param id
     * @param batch
     */
    addOrViewDraftPlan(id, batch) {
      if (!this.user.adminScore) {
        this.$alert("请先到客户信息栏完善高考成绩", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.$emit("goscore");
          },
        });
      } else {
        if (id) {
          let routeData = this.$router.resolve({
            path: "/addVolunteerPlan",
            query: {
              id: this.userid,
              idOne: this.idOne,
              draftId: id,
              batch: batch,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          // 选择批次
          this.dialogVisible = true;
        }
      }
    },
    /**
     * 添加志愿方案确认
     */
    addDraftPlanConfirm() {
      if (!this.draftform.planName || !this.draftform.planName.trim()) {
        this.$message.error("请输入方案名称");
        return;
      }
      if (!this.draftform.batch) {
        this.$message.error("请选择批次");
        return;
      }
      let routeData = this.$router.resolve({
        path: "/addVolunteerPlan",
        query: {
          id: this.userid,
          idOne: this.idOne,
          batch: this.draftform.batch.batch,
          voPa: this.draftform.batch.voPa,
          remark: this.draftform.remark,
          planName: this.draftform.planName,
        },
      });
      window.open(routeData.href, "_blank");
      this.dialogVisible = false;
    },

    showImportDraftPlan() {

      if (!this.user.adminScore) {
        this.$alert("请先到客户信息栏完善高考成绩", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.$emit("goscore");
          },
        });
      } else {
        this.dialogFormVisible = true
      }
    },

    showAddTemplateDialogClick() {
      if (!this.user.adminScore) {
        this.$alert("请先到客户信息栏完善高考成绩", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.$emit("goscore");
          },
        });
      } else {
        this.showAddTemplateDialog = true;
        this.expertParams.province = this.user.examProvince;
        this.obtainExpertList();

        this.obtainVolunteerTemplateList();
      }
    },

    reset() {
      this.planParams.year = this.user.graduateYear;
      this.planParams.expertId = "";
      this.selectDraftList = [];
      this.selectDraftIdList = [];
    },
    search() {
      this.planParams.current = 1;
      this.obtainVolunteerTemplateList();
    },
    /**
     * 获取志愿方案列表
     */
    obtainVolunteerTemplateList() {
      this.planParams.adminBatch = this.templateSelectBatch.batch
      this.planParams.disciplineType = this.user.disciplineType;
      getVolunteerTemplatePlan(this.planParams).then((res) => {
        if (res.code === 1) {
          this.planTotal = res.data.total;
          this.volunteerTemplateList = res.data.records || [];
        }
      });
    },

    pageChange(page) {
      this.planParams.current = page;
      this.obtainVolunteerTemplateList();
    },

    matchDisciplineType(type) {
      switch (type) {
        case 0:
          return "不分文理";
        case 1:
          return "理科";
        case 2:
          return "文科";
        case 3:
          return "物理类";
        case 4:
          return "历史类";
      }
    },

    matchVolunteerMode(mode) {
      switch (mode) {
        case 1:
          return "院校志愿";
        case 2:
          return "专业志愿";
        case 3:
          return "专业组志愿";
      }
    },
    /**
     * 省份筛选改变
     */
    provinceChange(province) {
      this.expertParams.province = province;
      this.obtainExpertList();
    },
    /**
     * 计算年份筛选
     */
    calculateYear() {
      let currentYear = new Date().getFullYear();
      for (let i = 4; i > 0; i--) {
        this.yearList.push(currentYear + i);
      }
      for (let i = 0; i < 8; i++) {
        this.yearList.push(currentYear - i);
      }
    },
    /**
     * 获取省份
     */
    async obtainProvinceList() {
      await getProvinceList().then((res) => {
        this.provinceList = res.data;
      });
    },
    /**
     * 获取专家列表
     */
    obtainExpertList() {
      getExpertList(this.expertParams).then((res) => {
        this.serviceExpertList = res.data || [];
      });
    },

    addDraftPlanFromTemplate() {
      if (this.selectDraftList.length === 0) {
        this.$message.warning("请选择志愿模板方案");
        return;
      }

      let volunteerMode = -1;
      let modeWarning = false;
      for (let item of this.selectDraftList) {
        if (volunteerMode === -1) {
          volunteerMode = item.voPa;
        } else {
          if (item.voPa === volunteerMode) {
            volunteerMode = item.voPa;
          } else {
            modeWarning = true;
            break;
          }
        }
      }

      if (modeWarning) {
        this.$message.warning("请选择志愿模式相同的志愿模板方案");
        return;
      }

      this.$confirm("确定将选择的模板添加到志愿草稿", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {

            addDraftPlanFromTemplate({
              draftIdList: this.selectDraftIdList,
              oneId: this.idOne,
              admitBatch: this.templateSelectBatch.batch,
              batchSort: this.templateSelectBatch.sort,
              batchVoPa: this.templateSelectBatch.voPa,
            }).then(res => {
              if (res.code === 1) {
                this.$message.success("添加成功");
                this.showAddTemplateDialog = false;
                this.getDraftList();
              } else {
                this.$message.error(res.msg);
              }
            }).catch(e => {

            })
          })
          .catch(() => {
          });
    },

    handleChange(file, fileList) {
      if (file.status === "ready") {
        this.fileList.push(file);
      }
    },
    fileRemove(file, fileList) {
      this.fileList = []
    },
    importFailed(err, file, fileList) {
      this.loading = false;
      this.fileList = []
      this.$message.error("导入失败");
    },
    importSuccess(res, file, fileList) {
      this.loading = false;
      this.fileList = []
      if (res.code === 1) {
        this.$refs.upload.clearFiles();
        this.$message.success("导入成功");
        this.getDraftList();
      } else {
        this.$confirm(res.msg, "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning",
        })
            .then(() => {
            })
            .catch(() => {
            });
      }
    },

    updatePlanNameClick(draftId) {
      this.updatePlanNameParam.draftId = draftId;
      this.updatePlanNameParam.planName = "";
      this.showUpdatePlanNameDialog = true;
    },

    updatePlanNameConfirm() {
      if (!this.updatePlanNameParam.planName) {
        this.$message.error("请输入方案名称");
        return;
      }
      updateDraftPlanName(this.updatePlanNameParam).then((res) => {
        if (res.code === 1) {
          this.$message.success("修改成功");
          this.showUpdatePlanNameDialog = false;
          this.getDraftList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flexsb {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.select-template-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .hint {
    color: #FF3333;
  }
}

.table {
  padding-top: 40px;
  position: relative;

  .button {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    top: 0px;

    .upload {
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}

.statusTv {
  color: #1ab394;
}
</style>
